/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Voice_Manager_Styles_Count_BadgeInputs */



/**
* | output |
* | --- |
* | "{count} styles" |
*
* @param {Voice_Manager_Styles_Count_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_styles_count_badge = /** @type {((inputs: Voice_Manager_Styles_Count_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Styles_Count_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} styles`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Stile`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} stili`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.count} стилей`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} estilos`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 种风格`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} スタイル`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} शैलियाँ`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} estilos`)
	return /** @type {LocalizedString} */ (`${i?.count} styles`)
});